"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePreferenceQuery = exports.QUERY = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _client = require("@apollo/client");
var _graphqlTag = _interopRequireDefault(require("graphql-tag"));
var _getLocaleFromPreferences = _interopRequireDefault(require("../../utils/getLocaleFromPreferences"));
var _templateObject;
const QUERY = exports.QUERY = (0, _graphqlTag.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  query preferencesAndUserDetails {\n    preferences {\n      userLanguage\n    }\n  }\n"])));
const usePreferenceQuery = () => {
  const {
    data
  } = (0, _client.useQuery)(QUERY, {
    fetchPolicy: 'cache-only'
  });
  return (0, _getLocaleFromPreferences.default)(data);
};
exports.usePreferenceQuery = usePreferenceQuery;